import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Image } from '@hover/blueprint';
import React from 'react';
import { animated } from 'react-spring';

import HOVERLogo from 'src/assets/icons/HOVERLogo.svg';

const scalingAnimation = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const BackgroundContainer = styled(animated.div)`
  position: absolute;
  height: 100vh;
  width: 100vw;
  animation: ${scalingAnimation};
  animation-duration: 1.2s;
`;

const BackgroundLogo = () => (
  <BackgroundContainer>
    <Image
      alt="logo"
      height="100%"
      src={HOVERLogo}
      style={{ objectFit: 'contain' }}
      width="100%"
    />
  </BackgroundContainer>
);

export { BackgroundLogo };
